import { isValid, toDate } from 'date-fns';
import type { TestFunction } from 'yup';

import { dateStringToTimestamp } from 'shared/lib/dates';

import { validatePassportDate } from './validatePassportDate';

export const isPassportDateCorrect: TestFunction = (value, context) => {
  const birthDateValue = String(context.parent.birthDate || '');

  // Не проверяем действительность паспорта, пока не заполнена дата рождения.
  if (!birthDateValue) {
    return true;
  }

  let shouldValid = false;
  if (value) {
    const birthDate = toDate(dateStringToTimestamp(birthDateValue));
    const passportIssueDate = toDate(dateStringToTimestamp(String(value)));

    if (isValid(birthDate) && isValid(passportIssueDate)) {
      shouldValid = validatePassportDate(birthDate, passportIssueDate);
    }
  }

  return shouldValid || context.createError({ path: context.path, message: 'Паспорт недействителен' });
};
